import environment from "../environment";
import { Post } from "./http.service";

const _endpooint = environment.AUTH_ENDPOINT;

export const login = async (requestBody) => {
  const response = await Post(`${_endpooint}/Token`, requestBody);
  return response;
};
